import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('component.nav.sidebar');
import { HostListener, OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-component-nav-sidebar',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/component.nav.sidebar/view.scss */
/* src/app/component.nav.sidebar/view.scss: no such file or directory */`],
})
export class ComponentNavSidebarComponent implements OnInit {
    public displayDate = new Date();

    @HostListener('window:kutdy-date-change', ['$event'])
    public async showDate(event: CustomEvent) {
        this.displayDate = new Date(event.detail);
        await this.service.render();
    }

    public courses: any[] = [];
    public shared: any[] = [];
    public deleted: string[] = [];
    public shareError = '';

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.refreshCourses();
    }

    @HostListener('window:ku-courses-changed')
    @HostListener('window:storage')
    public async refreshCourses() {
        if (!this.service.auth.status) { this.courses = []; this.shared = []; this.deleted = []; return; }
        try {
            const res: any = await wiz.app('component.page.share').call('handle', {action: 'list', data: '{}'});
            if (res.code !== 200) throw new Error('공유 페이지를 불러오지 못했습니다.');
            this.courses = res.data.owned;
            this.shared = res.data.shared;
            this.deleted = res.data.deleted || [];
            this.shareError = '';
        } catch (error: any) { this.shareError = error.message; }
        await this.service.render();
    }

    public isActive(link: string) {
        return location.pathname.indexOf(link) === 0
    }

    public activeClass(link: string) {
        if (this.isActive(link)) {
            return "group flex gap-x-2 items-center rounded-md bg-[#ff5b3b] px-3 py-2.5 text-[13px] font-medium text-white";
        }
        return "group flex gap-x-2 items-center rounded-md px-3 py-2.5 text-[13px] font-medium text-gray-600 hover:bg-orange-50 hover:text-orange-600";
    }
}

export default ComponentNavSidebarComponent;